import './privacy.css';

const TermsConditions = () => {
    return (
        <div className="body-div">
            <div className="policy-header">
                <div className="wrap text-center">
                    <p className="eyebrow">Legal</p>
                    <h1>Terms of Service at Twigaa.ai</h1>
                    <p className="lede policy-effective">Effective Date: 01-Jan-2025</p>
                </div>
            </div>

            <main className="wrap policy-body mt-5">
                <p className="policy-intro">By using Twigaa, you agree to the following terms.</p>

                <section className="policy-section">
                    <span className="policy-num">01</span>
                    <h2>Use of Service</h2>
                    <p>Twigaa provides a SaaS platform for travel operators to:</p>
                    <ul className="policy-list">
                        <li>Manage bookings</li>
                        <li>Generate itineraries</li>
                        <li>Send vouchers and communications</li>
                    </ul>
                    <p>You agree to use the platform only for lawful business purposes.</p>
                </section>

                <section className="policy-section">
                    <span className="policy-num">02</span>
                    <h2>Account Responsibility</h2>
                    <ul className="policy-list">
                        <li>You are responsible for maintaining the confidentiality of your account</li>
                        <li>You are responsible for all actions performed using your account</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">03</span>
                    <h2>Gmail Integration</h2>
                    <p>If you connect your Google account:</p>
                    <ul className="policy-list">
                        <li>You authorize Twigaa to send emails on your behalf</li>
                        <li>Twigaa will only send emails triggered by your actions</li>
                        <li>Twigaa does not access or read your inbox</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">04</span>
                    <h2>Acceptable Use</h2>
                    <p>You agree NOT to:</p>
                    <ul className="policy-list">
                        <li>Send spam or unauthorized emails</li>
                        <li>Use Twigaa for unlawful activities</li>
                        <li>Attempt to disrupt or misuse the platform</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">05</span>
                    <h2>Data Ownership</h2>
                    <ul className="policy-list">
                        <li>You retain ownership of your business data</li>
                        <li>Twigaa processes data only to provide services</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">06</span>
                    <h2>Service Availability</h2>
                    <p>We aim for high availability but do not guarantee uninterrupted service.</p>
                </section>

                <section className="policy-section">
                    <span className="policy-num">07</span>
                    <h2>Limitation of Liability</h2>
                    <p>Twigaa is not liable for:</p>
                    <ul className="policy-list">
                        <li>Loss of business due to service interruptions</li>
                        <li>Errors in data entered by users</li>
                        <li>Email delivery issues outside our control</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">08</span>
                    <h2>Termination</h2>
                    <p>We reserve the right to suspend accounts for:</p>
                    <ul className="policy-list">
                        <li>Misuse of the platform</li>
                        <li>Violation of these terms</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <span className="policy-num">09</span>
                    <h2>Changes to Terms</h2>
                    <p>We may update these terms periodically. Continued use implies acceptance.</p>
                </section>

                <section className="policy-section">
                    <span className="policy-num">10</span>
                    <h2>Contact Us</h2>
                    <p>For any questions, contact us at:</p>
                    <ul className="policy-list policy-contact-list mb-0 pb-5">
                        <li>
                            <a href="mailto:support@twigaa.ai" className="hanger-tag">
                                <span className="material-symbols-outlined">mail</span> support@twigaa.ai
                            </a>
                        </li>
                        <li>
                            <a href="https://twigaa.ai" target="_blank" rel="noopener noreferrer" className="hanger-tag">
                                <span className="material-symbols-outlined">language</span> https://twigaa.ai
                            </a>
                        </li>
                    </ul>
                </section>
            </main>
        </div>
    );
};
export default TermsConditions;